// ##############################
// // // Tasks for TasksCard - see Dashboard view
// #############################

var commandsUnsorting = [
  {
    label: "Reset: Núcleo",
    function: {
      CMD: "RESET_APP"
    }
  }, 
  {
    label: "Reset: QI",
    function: {
      CMD: "RESET_QI"
    }
  }, 
  {
    label: "Reset: UI",
    function: {
      CMD: "RESET_UI"
    }
  }, 
  {
    label: "Install: App (apk_install.apk)",
    function: {
      CMD: "INSTALL_APP"
    }
  }, 
  {
    label: "Install: UI (ui_install.apk)",
    function: {
      CMD: "INSTALL_UI"
    }
  }, 
  {
    label: "Abrir: Arquivo",
    function: {
      CMD: "FILE_OPEN"
    },
    fields: [
      {
        name: "fileName",
        value: "filename.apk"
      },
      // {
      //   name: "fileName2",
      //   value: "apk"
      // }
    ]
  }, 
  {
    label: "Assinatura: Enviar imagem",
    function: {
      CMD: "FILE_SIGNATURE_UPLOAD"
    },
    fields: [
      {
        name: "code",
        value: "0000000000"
      },
      // {
      //   name: "fileName2",
      //   value: "apk"
      // }
    ]
  }, 
  {
    label: "Chamar Tela: Gestão Núcleo",
    function: {
      CMD: "MANAGEMENT_SCREEN"
    },
    fields: [
      {
        name: "action",
        value: "enter",
        type: "checkbox",
        getValue: (val) => (val)?"enter":"exit"
      },
    ]
  }, 
  {
    label: "Chamar Tela: Certificação",
    function: {
      CMD: "CERTIFICATION_SCREEN"
    },
    fields: [
      {
        name: "action",
        value: "enter",
        type: "checkbox",
        getValue: (val) => (val)?"enter":"exit"
      },
    ]
  }, 
  {
    label: "Status Bar: Bloquear",
    function: {
      CMD: "STATUSBAR_BLOCK"
    },
    fields: [
      {
        name: "action",
        value: "yes",
        type: "checkbox",
        getValue: (val) => (val)?"yes":"no"
      },
    ]
  }, 
  {
    label: "Chamar Tela: Settings",
    function: {
      CMD: "SETTINGS_SCREEN"
    },
  },
  {
    label: "Arquivos: Autorenomear Condominos e Operadores",
    function: {
      CMD: "AUTO_RENAME_UI_FILES"
    }
  },  
  {
    label: "Websocket: Start",
    function: {
      CMD: "START_WEBSOCKET"
    }
  },
  {
    label: "Websocket: Close",
    function: {
      CMD: "CLOSE_WEBSOCKET"
    }
  }, 
  {
    label: "Firmware: Atualizar",
    function: {
      CMD: "UPDATE_FIRMWARE"
    },
    fields: [
      {
        name: "firmwareName",
        value: "firmwareHex.txt"
      },
    ]
  }, 
  {
    label: "Arquivo CSV: Exportar",
    function: {
      CMD: "EXPORT_CSV_FILE"
    },
    fields: [
      {
        name: "fileType",
        value: "ORDERS",
        type: "checkbox",
        getValue: (val) => (val)?"ORDERS":"SLOTS"
      },
    ]
  },
  {
    label: "Arquivo CSV: Importar",
    function: {
      CMD: "IMPORT_CSV_FILE"
    },
    fields: [
      {
        name: "fileName",
        value: "filename.csv"
      },
      {
        name: "SlotsOrOrders",
        value: "ORDERS",
        type: "checkbox",
        getValue: (val) => (val)?"ORDERS":"SLOTS"
      }
    ]
  },
  {
    label: "Reset: Log",
    function: {
      CMD: "RESET_LOG"
    }
  }, 
  {
    label: "Chamar Tela: App de Início (Kiosk)",
    function: {
      CMD: "CALL_KIOSK"
    }
  },
  {
    label: "Kerong: Configurar tempo de abertura",
    function: {
      CMD: "SET_KERONG_UNLOCKING_TIME"
    },
    fields: [
      {
        name: "unlockingTime",
        value: "550",
        cast: "number"
      },
    ]
  },
  {
    label: "Reset: Database",
    function: {
      CMD: "RESET_DATABASE"
    },
    fields: [
      {
        name: "action",
        value: "no",
        type: "checkbox",
        getValue: (val) => (val)?"yes":"no"
      },
    ]
  }, 


  

  // {
  //   label: "Upload File",
  //   function: {
  //     CMD: "FILE_UPLOAD",
  //     fileName: ""
  //   }
  // }, 
  // {
  //   label: "Download File",
  //   function: {
  //     CMD: "FILE_DOWNLOAD",
  //     fileName: "",
  //     url: ""
  //   }
  // },  
];

const files = [
  {
    value: "config.json"
  }, 
  {
    value: "log.txt"
  }
]

const commands = commandsUnsorting.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))



module.exports = {
  // these 3 are used to create the tasks lists in TasksCard - Dashboard view
  commands,
  files
};
